"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ContinuousColorScale = _interopRequireDefault(require("./ContinuousColorScale"));

var _DiscreteColorScale = _interopRequireDefault(require("./DiscreteColorScale"));

var _Scale = require("./Scale");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Colors = function Colors(_ref) {
  var height = _ref.height,
      props = _objectWithoutProperties(_ref, ["height"]);

  var _useScaleContext = (0, _Scale.useScaleContext)(),
      colors = _useScaleContext.colors,
      type = _useScaleContext.type,
      margin = _useScaleContext.margin,
      width = _useScaleContext.width,
      chunks = _useScaleContext.chunks;

  return (0, _utils.isContinuous)(type) ? /*#__PURE__*/_react["default"].createElement(_ContinuousColorScale["default"], _extends({
    colors: colors,
    margin: margin,
    width: width,
    height: height
  }, props)) : /*#__PURE__*/_react["default"].createElement(_DiscreteColorScale["default"], _extends({
    chunks: chunks,
    margin: margin,
    height: height,
    width: width
  }, props));
};

Colors.propTypes = {
  /** height of the color scale */
  height: _propTypes["default"].number
};
Colors.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Colors",
  "props": {
    "height": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "height of the color scale"
    }
  }
};
var _default = Colors;
exports["default"] = _default;